import { IListItemSimple } from "../contracts/ListUtility";
import { ZeosListEnum, ZeosListOptionEnum } from "../enums/ListUtility";
import { getDataAsync } from "../ZeosApiExecutor";
import { IListUtility } from "./interfaces/IListUtility";

const utilityPrefix = "/List";

export const ListUtility: IListUtility = {
  getListAsync: async (
    listType: ZeosListEnum,
    listOption: ZeosListOptionEnum | null = ZeosListOptionEnum.all
  ) => {
    let url = `${utilityPrefix}/${listType}`;
    url = listOption ? `${url}/${listOption}` : url;
    return await getDataAsync<IListItemSimple[]>(url, "");
  },
};
